// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var CssGrid = require("components/CssGrid");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
var PropertyWizardFormRelay__Elements = require("./PropertyWizardFormRelay__Elements.bs.js");
var PropertyWizardFormRelay__Validators__Description = require("./PropertyWizardFormRelay__Validators__Description.bs.js");
var PropertyWizardRelayDescriptionDescription_draft_graphql = require("../../../__generated__/PropertyWizardRelayDescriptionDescription_draft_graphql.bs.js");

var convertFragment = PropertyWizardRelayDescriptionDescription_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayDescriptionDescription_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescriptionDescription_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayDescriptionDescription_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayDescriptionDescription_draft_graphql.node, convertFragment, fRef);
}

var DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__Description__Description(props) {
  var draft = use(props.draft);
  var descriptionIsValid = PropertyWizardFormRelay__Validators__Description.Description.useIsValid(draft.fragmentRefs);
  var description = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "DraftProperty",
        _0: (function (dp, value) {
            var newrecord = Caml_obj.obj_dup(dp);
            newrecord.description = value;
            return newrecord;
          })
      }, props.stepHasBeenTouched, draft.draftProperty.description, descriptionIsValid);
  var match = React.useState(function () {
        return draft.draftProperty.description;
      });
  return JsxRuntime.jsxs(CssGrid.Cell, {
              width: 12,
              children: [
                JsxRuntime.jsx(PropertyWizardFormRelay__Elements.RichTextEditorField.make, {
                      labelText: "Description",
                      onChange: (function (param) {
                          description.onChange(param.content);
                        }),
                      onBlur: (function (param) {
                          description.onBlur();
                        }),
                      initialContent: match[0],
                      status: description.status
                    }),
                JsxRuntime.jsx(Form__Components.FieldError.make, {
                      valid: description.valid
                    })
              ]
            });
}

var Components;

var TextInputField;

var Cell;

var Validators;

var FormUtils;

var Elements;

var make = PropertyWizardRelay__Description__Description;

exports.Components = Components;
exports.TextInputField = TextInputField;
exports.Cell = Cell;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.Elements = Elements;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* react Not a pure module */
